export const getDocumentLanguage = (): string | undefined => {
    const htmlLang = document.documentElement?.lang?.trim();

    return htmlLang && htmlLang.length > 0 ? htmlLang : undefined;
};
